import { TicketCategory, TicketPriority, TicketStatus } from '@hrms/shared/types';

/* ── Tickets - Constants ── */

export type TicketTabKey =
  | 'all'
  | 'open'
  | 'in_progress'
  | 'resolved'
  | 'closed'
  | 'my'
  | 'watching'
  | 'overdue';

export const TICKET_TABS: {
  key: TicketTabKey;
  label: string;
}[] = [
  { key: 'all', label: 'All' },
  { key: 'open', label: 'Open' },
  { key: 'in_progress', label: 'In Progress' },
  { key: 'resolved', label: 'Resolved' },
  { key: 'closed', label: 'Closed' },
  { key: 'my', label: 'My Tickets' },
  { key: 'watching', label: 'Watching' },
  { key: 'overdue', label: 'Overdue' },
];

export const TICKET_QUICK_TRANSITIONS: Partial<
  Record<
    TicketStatus,
    {
      status: TicketStatus;
      label: string;
      icon: string;
    }[]
  >
> = {
  [TicketStatus.OPEN]: [
    {
      status: TicketStatus.IN_PROGRESS,
      label: 'Start Progress',
      icon: 'play_arrow',
    },
  ],

  [TicketStatus.IN_PROGRESS]: [
    {
      status: TicketStatus.RESOLVED,
      label: 'Mark Resolved',
      icon: 'task_alt',
    },
  ],

  [TicketStatus.RESOLVED]: [
    {
      status: TicketStatus.CLOSED,
      label: 'Close Ticket',
      icon: 'archive',
    },
    {
      status: TicketStatus.OPEN,
      label: 'Reopen',
      icon: 'refresh',
    },
  ],
};

export const DEFAULT_TICKET_FORM = {
  title: '',
  description: '',
  category: TicketCategory.SUPPORT,
  priority: TicketPriority.MEDIUM,
  tags: [] as string[],
  assignedTo: '',
};

export const TICKET_ATTACHMENT_ALLOWED_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv',
];

export const TICKET_MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;

export const TICKET_SEARCH_DEBOUNCE_MS = 500;

export const TICKET_MESSAGE_TIMEOUT_MS = 2000;

export const TICKET_ACTION_MENU_HEIGHT_ESTIMATE = 190;

export const TICKET_DEFAULT_PAGE_SIZE = 25;

export const TICKET_PAGE_SIZE_OPTIONS = [
  10,
  25,
  50,
  100,
];

export const TICKET_ASSIGN = {
  TEAM_LABEL: 'Assign Team',
  ASSIGN_TO_LABEL: 'Assign To',
  TEAM_PLACEHOLDER: 'Select a team',
  EMPLOYEE_PLACEHOLDER: 'Select an employee',
  SELECT_TEAM_FIRST: 'Select a team first',
};


export const TICKET_DETAIL = {
  BACK_BUTTON: 'Back to Tickets',
  ACTIONS: 'Actions',
  WATCH: 'Watch',
  UNWATCH: 'Unwatch',
  MARK_IN_PROGRESS: 'Mark In Progress',
  MARK_RESOLVED: 'Mark Resolved',
  CLOSE_TICKET: 'Close Ticket',
  ASSIGN_TICKET: 'Assign Ticket',
  NOT_FOUND: 'Ticket not found',
  CREATED_BY: 'Created',
} as const;
